<template>
  <!-- 个人中心 -->
  <div id="views_userCenterNew_UserCenterNew">
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
#views_userCenterNew_UserCenterNew{
  width: 100vw;
  height: 100vh;
  .ucn_mainbox{
    width: 80%;
    margin: auto;
    .ucn_header{
      height: 227px;
      display: flex;
      align-items: center;
    }
    .ucn_typeline{
      height: 152px;
      margin-top: 30px;
    }
  }
}
</style>
